import React from 'react';

const sizeMap = {
  sm: 'w-5 h-5 border-2',
  md: 'w-8 h-8 border-[3px]',
  lg: 'w-12 h-12 border-4',
};

/**
 * Spinner: 로딩 인디케이터
 * Usage (인라인): <div className="flex justify-center py-8"><Spinner /></div>
 *        (오버레이 내부): <Spinner size="lg" />
 */
export default function Spinner({ size = 'md' }) {
  return (
    <div className={`${sizeMap[size]} rounded-full border-mono-200 border-t-orange-500 animate-spin`} />
  );
}
